import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "d-flex flex-row align-center justify-center ga-2"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mf_icon = _resolveComponent("mf-icon");
                                                          
                                                      
  return $props.type === 'icon' ? (_openBlock(), _createBlock(_component_v_btn, {
    key: 0,
    block: $props.block,
    color: $props.color,
    theme: $options.getIsDark ? 'dark' : 'light',
    variant: $options.getIconVariant,
    disabled: $props.disabled,
    icon: "",
    size: $options.getVuetifySize,
    "input-value": $props.inputValue,
    onClick: _cache[0] || (_cache[0] = $event => $options.clickButton($event)),
    onMousedown: _cache[1] || (_cache[1] = $event => _ctx.$emit('mousedown')),
    onMouseleave: _cache[2] || (_cache[2] = $event => _ctx.$emit('mouseleave')),
    onMouseup: _cache[3] || (_cache[3] = $event => _ctx.$emit('mouseup'))
  }, {
    default: _withCtx(() => [_createVNode(_component_v_badge, {
      class: _normalizeClass($props.block ? 'mf-block-badge' : ''),
      color: $props.badgeColor,
      content: $props.badgeContent,
      "model-value": $props.badgeContent > 0,
      "offset-x": -10,
      "offset-y": -15
    }, {
      default: _withCtx(() => [_createVNode(_component_mf_icon, {
        color: $options.getIconColor,
        fill: $props.fill,
        icon: $props.icon,
        size: $options.getIconButtonSize
      }, null, 8, ["color", "fill", "icon", "size"])]),
      _: 1
    }, 8, ["class", "color", "content", "model-value"])]),
    _: 1
  }, 8, ["block", "color", "theme", "variant", "disabled", "size", "input-value"])) : (_openBlock(), _createBlock(_component_v_btn, {
    key: 1,
    block: $props.block,
    class: _normalizeClass(["mf-button", $options.getButtonClass]),
    color: $props.color,
    theme: $options.getIsDark ? 'dark' : 'light',
    variant: $options.getVariant,
    disabled: $props.disabled,
    elevation: $props.depressed ? 0 : 2,
    "input-value": $props.inputValue,
    loading: $props.loading,
    onClick: _cache[4] || (_cache[4] = $event => $options.clickButton($event)),
    onMousedown: _cache[5] || (_cache[5] = $event => _ctx.$emit('mousedown')),
    onMouseleave: _cache[6] || (_cache[6] = $event => _ctx.$emit('mouseleave')),
    onMouseup: _cache[7] || (_cache[7] = $event => _ctx.$emit('mouseup'))
  }, {
    default: _withCtx(() => [_createVNode(_component_v_badge, {
      "data-testid": "badge",
      class: _normalizeClass($props.block ? 'mf-block-badge' : ''),
      color: $props.badgeColor,
      content: $props.badgeContent,
      "model-value": $props.badgeContent > 0,
      "offset-x": -10,
      "offset-y": -15
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$props.iconPosition === 'right' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.label), 1)) : _createCommentVNode("", true), $props.icon ? (_openBlock(), _createBlock(_component_mf_icon, {
        key: 1,
        color: $options.computedIconColor,
        fill: $props.fill,
        icon: $props.icon,
        size: $options.getIconSize
      }, null, 8, ["color", "fill", "icon", "size"])) : _createCommentVNode("", true), $props.iconPosition === 'left' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.label), 1)) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["class", "color", "content", "model-value"])]),
    _: 1
  }, 8, ["block", "class", "color", "theme", "variant", "disabled", "elevation", "input-value", "loading"]));
}

/* Vuetify */
import { VBadge as _component_v_badge } from "vuetify/components/VBadge"
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"

